import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {GET_ENV_VARIABLES} from "./actionTypes";
import {setEnvironmentVariables} from "./actions";
import {getVariables} from "../../../helpers/variables";
import {LOGIN_USER_SUCCESS} from "../login/actionTypes";
import store from "../..";

function* getEnvironmentVariables({ payload: { org = store.getState().Variables.org } }) {
    try {
        const response = yield call(getVariables, org);
        yield put(setEnvironmentVariables({ vars: response, error: null })); // Dispatch success action
    } catch (error) {
        console.error("Error fetching environment variables:", error);
        yield put(setEnvironmentVariables({ error: error.message })); // Handle errors properly
    }
}

export function* watchLoginSuccess() {
    yield takeEvery(LOGIN_USER_SUCCESS, getEnvironmentVariables);
}

export function* watchGetVariables() {
    yield takeEvery(GET_ENV_VARIABLES, getEnvironmentVariables);
}

function* variablesSaga() {
    yield all([fork(watchGetVariables), fork(watchLoginSuccess)]);
}

export default variablesSaga;
